module.exports = __webpack_public_path__ + "static/media/fish_english.83e372b9.png";